<template>
  <v-card outlined class="pa-4 ma-0 d-flex flex-column gap-3" style="height: 350px">
    <!-- Header -->
    <v-container class="chart-header d-flex justify-space-between pa-0 ma-0">
      <v-card-text class="pa-0 ma-0 text-body-1">
        {{ $t("most_used_reports") }}
      </v-card-text>
      <v-icon class="pa-0 ma-0">mdi-chart-bar</v-icon>
    </v-container>

    <!-- List -->
    <v-list dense class="pa-0 ma-0 scroll-y">
      <v-container v-for="(item, index) in reports" :key="index" class="pa-0 ma-0">
        <!-- Row -->
        <v-container
          class="pa-0 ma-0 d-flex align-center py-3 report-row"
          @click="goToReport(item)"
          style="cursor: pointer"
        >
          <!-- Text -->
          <v-container class="pa-0 ma-0 d-flex">
            <v-container
              class="icon-wrapper pa-4 ma-0 d-flex align-center justify-center"
              :style="{ backgroundColor: item.bgColor }"
            >
              <v-icon :color="item.iconColor" size="18">
                {{ item.icon }}
              </v-icon>
            </v-container>
            <v-container class="pa-0 py-1 mr-3 ma-0 d-flex flex-column">
              <v-card-text class="text-body-2 pa-0 ma-0">
                {{ item.title }}
              </v-card-text>
              <v-card-text class="text-caption grey--text pa-0 ma-0">
                {{ item.count }}
              </v-card-text>
            </v-container>
          </v-container>
          <v-icon size="18" color="grey lighten-1" class="ml-2 flex-grow-1">
            mdi-chevron-right
          </v-icon>
        </v-container>

        <!-- Divider -->
        <v-divider v-if="index !== reports.length - 1" />
      </v-container>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "PeriodicReports",

  data() {
    return {
      reports: [
        {
          title: "گزارشات فروش",
          icon: "mdi-cart-outline",
          iconColor: "#1976D2",
          bgColor: "#E3F2FD",
          routeName: "bIsell",
        },
        {
          title: "گزارشات خرید",
          icon: "mdi-cube-outline",
          iconColor: "#E65100",
          bgColor: "#FFF3E0",
          routeName: "bIbuy",
        },
        {
          title: "گزارشات انبار",
          icon: "mdi-trending-up",
          iconColor: "#6A1B9A",
          bgColor: "#F3E5F5",
          routeName: "bIwarehouse",
        },
        {
          title: "گزارشات تنخواه",
          icon: "mdi-chart-bar",
          iconColor: "#2E7D32",
          bgColor: "#E8F5E9",
          routeName: "bIpetty",
        },
      ],
    };
  },
  methods: {
    goToReport(item) {
      this.$router.push({ name: item.routeName });
    },
  },
};
</script>
<style scoped>
.icon-wrapper {
  width: 40px;
  height: 40px;
  padding: 5px;
  border-radius: 12px;
}
.report-row {
  transition: background-color 0.15s ease;
}
.report-row:hover {
  background-color: #f7f8fa;
}
.scroll-y {
  overflow-y: auto;
  scrollbar-width: none;
}
.scroll-y::-webkit-scrollbar {
  display: none;
}
</style>
